// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const serviciosEnvioFullfilledReducer = makeSetReducer(['servicios_envio/fullfilled']);
